import React from "react";
import { Card, Tooltip } from "antd";
import { BiInfoCircle } from "react-icons/bi";

interface CardLayoutProps {
  className: string;
  title: React.ReactNode;
  loading: boolean;
  tooltipText?: string;
  children: React.ReactNode;
}

export default function CardLayout({
  className,
  title,
  loading,
  tooltipText,
  children,
}: CardLayoutProps): React.ReactElement {
  return (
    <Card
      className={`card-wrapper ${className}`}
      loading={loading}
      extra={
        tooltipText && (
          <Tooltip title={tooltipText}>
            <BiInfoCircle size={18} />
          </Tooltip>
        )
      }
      title={title}
    >
      {children}
    </Card>
  );
}
